/**
 * 全局事件分发
 */

export class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }

    /**
     * 监听事件
     * @param event 事件名
     * @param listener 事件处理函数
     * @param once 是否只监听一次
     */
    on(event, listener, once = false) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, []);
        }
        const listeners = this.listeners.get(event);
        listeners.push(once ? this.onceWrapper(event, listener) : listener);
    }

    /**
     * 只监听一次的事件
     * @param event 事件名
     * @param listener 事件处理函数
     */
    once(event, listener) {
        this.on(event, listener, true);
    }

    /**
     * 触发事件
     * @param event 事件名
     * @param args 传递给监听器的参数
     */
    emit(event, ...args) {
        if (this.listeners.has(event)) {
            const listeners = this.listeners.get(event)?.slice(); // 复制数组以避免在迭代时修改
            for (const listener of listeners) {
                listener(...args);
            }
        }
    }

    /**
     * 移除事件监听器
     * @param event 事件名
     * @param listener 要移除的监听器，如果不提供，则移除所有监听器
     */
    off(event, listener) {
        if (this.listeners.has(event)) {
            if (listener && this.listeners.get(event)) {
                this.listeners.set(event, this.listeners.get(event)?.filter(l => l !== listener));
            }
            else {
                this.listeners.delete(event);
            }
        }
    }

    /**
     * 包装只监听一次的监听器
     * @param listener 原始监听器
     */
    onceWrapper(event, listener) {
        const wrapper = (...args) => {
            listener(...args);
            this.off(event, wrapper);
        };
        return wrapper;
    }
}

// 事件名
export const ACTION = 'channel.popup';

export class PopupEmitter extends EventEmitter {
    constructor(action = '') {
        super();
        this.action = action ? ACTION + action : ACTION;
    }

    static getInstance() {
        if (!PopupEmitter.instance) {
            PopupEmitter.instance = new PopupEmitter();
        }
        return PopupEmitter.instance;
    }

    reverse(action) {
        return action.split('').reverse().join('');
    }

    registerBroadcast(callback, reverse = true, action = this.action) {
        this.on(reverse ? this.reverse(action) : action, callback);
    }

    unRegisterBroadcast(reverse = true, action = this.action) {
        this.off(reverse ? this.reverse(action) : action);
    }

    sendBroadcast(data, reverse = true, action = this.action) {
        this.emit(reverse ? this.reverse(action) : action, data);
    }
}